var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w1200 auto confirm-order-panel"},[_c('div',{staticClass:"confirm-order-title"},[_vm._v(_vm._s(_vm.titleName))]),_vm._v(" "),_c('div',{staticClass:"confirm-order-body"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@15.9.1@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.1@vue-loader/lib??vue-loader-options!./src/components/confirm-order-panel.vue?vue&type=template&id=8e7c0c9a&
// module id = 54
// module chunks = 0